const React = require("react");
const createReactClass = require("create-react-class");
const PT = require("prop-types");

const PageBackdropImage = require("./PageBackdropImage");
const WonkyButton = require("../view/WonkyButton");
const MarqueeTexts = require("./util/MarqueeTexts");
const RandomUtil = require("../util/RandomUtil");
const moment = require("moment");
const styles = require("./styles/PageHome.css");
const {PLAYWRIGHT_TEST_IDS} = require("../../../shared/PlaywrightTestIds");

module.exports = createReactClass({
	displayName: "PageHomeBuilding",

	propTypes: {
		imageSrc: PT.string,
		imageStyle: PT.string,
		buildingName: PT.string,
		buttonProps: PT.object,
	},

	makeButton: function() {
		return this.props.buttonProps ? (
			<WonkyButton {...this.props.buttonProps} />
		) : null;
	},

	render: function() {
		const image = (
			<PageBackdropImage
				imageSrc={this.props.imageSrc}
				imageStyle={this.props.imageStyle}
			/>
		);
		const button = this.makeButton();
		let textForMarquee = null;
		if (this.props.buildingName === "theater") {
			const time = moment().format("YYYY-MM-DD");
			const marqueeIndex = RandomUtil.pseudoRandomInt(time, {
				min: 0,
				max: MarqueeTexts.marqueeTexts.length - 1,
			})();
			const [leftMarqueeText, rightMarqueeText] = MarqueeTexts.marqueeTexts[
				marqueeIndex
			];
			textForMarquee = (
				<React.Fragment>
					<div
						className={`${styles.marquee} ${styles.marqueeLeft}`}
						data-testid={PLAYWRIGHT_TEST_IDS.HOME_LEFT_MARQUEE}
					>
						{leftMarqueeText}
					</div>
					<div
						className={`${styles.marquee} ${styles.marqueeRight}`}
						data-testid={PLAYWRIGHT_TEST_IDS.HOME_RIGHT_MARQUEE}
					>
						{rightMarqueeText}
					</div>
				</React.Fragment>
			);
		}
		return (
			<React.Fragment>
				{image}
				{textForMarquee}
				{button}
				{this.props.children}
			</React.Fragment>
		);
	},
});
